import { useState } from "react";
import useDebtWarehouseTab from "../../hooks/useDebtWarehouseTab";
import { Stack, Box, Button, Typography } from "@mui/material";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import TableComp from "src/components/shared/table/TableComp";
import DebtFilter from "../../components/DebtFilter";
import { DebtWarehouseBulkPaymentDialog, DebtWarehouseHistoryDetailDialog } from "../Dialogs";
import { formatCurrency } from "src/helper/convertNum";
import convertCurrency from "src/helper/convertCurrency";
import { enqueueSnackbar } from "notistack";
import { DEBT_COLOR_OUTBOUND } from "../../utils/renderDebtAmountByInventoryType";

const DebtWarehouseTab = ({ date }) => {
  const [exportedCode, setExportedCode] = useState();
  const [isMultiplePayment, setIsMultiplePayment] = useState(false);
  const [filter, setFilter] = useState();

  const { bodyList, pagi, total, setPagi, sortData, header, totalImportDebt, setSelectedRow, selectedRow, checkedList, detailSelectedRow, setDetailSelectedRow } =
    useDebtWarehouseTab({
      date,
      exportedCode,
      filter,
    });

  const handleClosePayment = () => {
    setSelectedRow(null);
    setIsMultiplePayment(false);
  };

  const handleMultiplePayment = () => {
    if (checkedList.length) {
      const distinctDebtWarehouse = new Set(checkedList.map((item) => item?.warehouseDebt?._id));
      if (distinctDebtWarehouse.size > 1) {
        enqueueSnackbar("Không thể thanh toán hàng loạt công nợ với kho nhận khác nhau", { variant: "error" });
        return;
      }
    }
    setIsMultiplePayment(true);
  };

  const handleCloseDetail = () => {
    setDetailSelectedRow(null);
  };

  console.log(filter);

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        my="14px"
      >
        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
          minWidth="198px"
        >
          <SearchFilterComp
            getSearchKeyword={setExportedCode}
            placeholder="Mã phiếu xuất"
            width="100%"
          />
        </Box>
        <Stack
          direction="row"
          gap={2}
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleMultiplePayment}
          >
            Thanh toán hàng loạt
          </Button>
          <DebtFilter
            variant="internal-import"
            setParamsQuery={setFilter}
            paramsQuery={filter}
          />
        </Stack>
      </Stack>
      <TableComp
        bodyList={bodyList}
        headers={header}
        sortData={sortData}
        setPagi={setPagi}
        pagi={pagi}
        total={total}
        noBackground
        TableFooterComponent={
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            spacing={4}
            sx={{ py: 2, borderTop: "1px solid var(--grey)" }}
          >
            <Typography fontWeight="bold">Tổng:</Typography>
            <Stack alignItems="center">
              <Typography
                fontWeight="bold"
                sx={{ color: DEBT_COLOR_OUTBOUND }}
              >
                +{formatCurrency(Math.abs(totalImportDebt ?? 0))}
              </Typography>
              <Typography
                color="#989898"
                fontSize="8px"
                fontStyle="italic"
              >
                {convertCurrency(totalImportDebt)} đồng
              </Typography>
            </Stack>
          </Stack>
        }
      />
      <DebtWarehouseBulkPaymentDialog
        open={!!selectedRow || isMultiplePayment}
        onClose={handleClosePayment}
        isMultiplePayment={isMultiplePayment}
        title={!selectedRow ? "Thanh toán hàng loạt công nợ hàng nhập" : `Thanh toán công nợ ${selectedRow?.code}`}
        selectedRow={selectedRow}
        checkedList={checkedList}
      />
      <DebtWarehouseHistoryDetailDialog
        open={!!detailSelectedRow}
        onClose={handleCloseDetail}
        selectedRow={detailSelectedRow}
        isAllTab={true}
      />
    </>
  );
};

export default DebtWarehouseTab;
